import React from "react";
import "./inputForm.css";

const Input = ({
  onClick,
  onChange,
  placeholder,
  label,
  type,
  addClassLabel,
  addClassInput,
  addClassError,
  value,
  selectOptions,
  error,
  readOnly,
  maxDate,
  maxTextLength,
  disabledValue,
  minValue,
  maxValue,
  autoFocus,
  refVar
}) => {
  const userControl = (
    e
  ) => {
    if (onChange) {
      onChange(e);
    } else {
      return;
    }
  };

  const handleClick = () => {
    if (onClick && !readOnly) {
      onClick();
    } else {
      return;
    }
  };

  return (
    < div >
      <div>
        {label !== undefined && (
          <div
            className={`input-form-input-label ${addClassLabel ? addClassLabel : ""
              }`}
          >
            {label}
          </div>
        )}
        {type === "select" && (
          <select
            placeholder={placeholder}
            className={`input-form-relation-input ${addClassInput ? addClassInput : ""
              }`}
            name={label}
            value={value}
            onChange={userControl}
            disabled={readOnly}
          >
            {typeof selectOptions !== "undefined" &&
              selectOptions.map((opt, index = 0) =>
                opt.value === "" ? (
                  <option key={`${opt.value}${index++}select`} value="" disabled>
                    {opt.label}
                  </option>
                ) : (
                    <option key={`${opt.value}${index++}select`} value={opt.value}>
                      {opt.label}
                    </option>
                  )
              )}
          </select>
        )}
        {type === "button" && (
          <div
            className={`input-form-button-input ${addClassInput ? addClassInput : ""
              }`}
            onClick={disabledValue === true ? () => { } : handleClick}
          >
            {value}
          </div>
        )}
        {type === "text" && (
          <input
            readOnly={readOnly}
            placeholder={placeholder}
            className={`input-form-text-input ${addClassInput ? addClassInput : ""
              }`}
            type="text"
            value={value}
            maxLength={maxTextLength}
            onChange={userControl}
            autoFocus={autoFocus}
          />
        )}
        {type === "number" && (
          <input
            readOnly={readOnly}
            placeholder={placeholder}
            className={`input-form-text-input ${addClassInput ? addClassInput : ""
              }`}
            type="number"
            value={value}
            maxLength={maxTextLength}
            onChange={userControl}
            min={minValue}
            max={maxValue}
            autoFocus={autoFocus}
            ref={refVar}
          />
        )}
        {type === "pin" && (
          <input
            readOnly={readOnly}
            placeholder={placeholder}
            className={`input-form-text-input ${addClassInput ? addClassInput : ""
              }`}
            type="password"
            maxLength={4}
            value={value}
            onChange={userControl}
          />
        )}
        {type === "date" && (
          <input
            readOnly={readOnly}
            placeholder={placeholder}
            className={`input-form-text-input ${addClassInput ? addClassInput : ""
              }`}
            type="date"
            max={maxDate}
            value={value}
            onChange={userControl}
          />
        )}
      </div>
      {error && <div className={`form-element-error ${addClassError ? addClassError : ""}`}>{error}</div>}
    </div >
  );
};

export default Input;
